export enum RepliersListingStyle {
  // TREB - Residential
  'Apartment' = 'Apartment',
  'Bungalow' = 'Bungalow',
  'BungalowRaised' = 'Bungalow-Raised',
  'Bungaloft' = 'Bungaloft',
  'Storey_1AndAHalf' = '1 1/2 Storey',
  'Storey_2' = '2-Storey',
  'Storey_2AndAHalf' = '2 1/2 Storey',
  'Storey_3' = '3-Storey',
  'MultiLevel' = 'Multi-Level',
  'StackedTownhouse' = 'Stacked Townhse',
  'Backsplit_3' = 'Backsplit 3',
  'Backsplit_4' = 'Backsplit 4',
  'Backsplit_5' = 'Backsplit 5',
  'Backsplit_All' = 'Backsplt-All',
  'Sidesplit_3' = 'Sidesplit 3',
  'Sidesplit_4' = 'Sidesplit 4',
  'Sidesplit_5' = 'Sidesplit 5',
  'Sidesplit_All' = 'Sidesplt-All',
  'BachelorStudio' = 'Bachelor/Studio',
  'Loft' = 'Loft',
  'IndustrialLoft' = 'Industrial Loft',
  'WarehouseLoft' = 'Warehouse Loft',
  'Other' = 'Other',

  'Storey_1_Rare' = '1', // Almost never used
  'Storey_2_Rare' = '2 Storey', // Almost never used
  'Storey_2_Rare2' = '2', // Almost never used
  'Storey_2AndAHalf_Rare' = '2-1/2 Storey', // Almost never used
  'Storey_3_Rare' = '3 Storey', // Almost never used
  'Storey_3_Rare2' = '3', // Almost never used

  // TREB - Commercial
  'Office' = 'Office',
  'Retail' = 'Retail',
  'WithoutProperty' = 'Without Property',
  'MultiUse' = 'Multi-Use',
  'MultiUnit' = 'Multi-Unit',
  'Designated' = 'Designated',
  'FreeStanding' = 'Free Standing',
  'CommercialCondo' = 'Commercial Condo',
  'IndustrialCondo' = 'Industrial Condo',
  'StoreWithApartmentOffice' = 'Store With Apt/Office',
  'Service' = 'Service',
  'WithProperty' = 'With Property',
  'Agricultural' = 'Agricultural',
  'RawOutsideOfficialPlan' = 'Raw (Outside Official Plan)',
  'HighwayCommercial' = 'Highway Commercial',
  'Accommodation' = 'Accommodation',
  'Institutional' = 'Institutional',
  'Industrial' = 'Industrial',
  'Recreational' = 'Recreational',
  'BusinessPlus' = 'Business +',

  // ITSO Extras
  'OneStoreyOrApt' = '1 Storey/Apt', // Other
  'Sidesplit' = 'Sidesplit', // Split-level
  'Backsplit' = 'Backsplit', // Split-level
  'SplitLevel' = 'Split Level', // Split-level
  'MultiLevelSplit' = 'Multi-Level Split', // Split-level
  'Cottage' = 'Cottage', // Cottage
  'Chalet' = 'Chalet', // Cottage
  'Log' = 'Log', // Cottage
  'AFrame' = 'A-Frame', // Cottage
  'Mobile' = 'Mobile', // Other
  'Link' = 'Link', // Other
  'Contemporary' = 'Contemporary', // Other
  'GardenHouse' = 'Garden House', // Other
}
